import classNames from 'classnames';

interface IDefaultCell {
  data: string | number;
  isEllipsis?: boolean;
  textCapitalize?: boolean;
  className?: string;
}

const DefaultCell = (props: IDefaultCell) => {
  const { data, isEllipsis = false, textCapitalize = true, className = '' } = props;

  const draftClassNames = classNames(className, 'fs-6', {
    'text-capitalize': textCapitalize,
    'oa-table-cell-ellipsis': isEllipsis
  });

  return (
    <div className={draftClassNames} title={data ? data.toString() : ''}>
      {data}
    </div>
  );
};

export default DefaultCell;
